import { useViewportStore } from '@/store/useViewportStore';
import { Children, ReactNode } from 'react';
import styled from 'styled-components';
import ExperienceProductCard from './ProductCard/ExperienceProductCard';

interface ExperienceProductGridProps {
  data?: ExperienceProduct[];
  // 전체 탭처럼 혼합 카드를 직접 넣어야 할 때 카드 슬롯을 넘긴다(미지정 시 data로 체험 카드 렌더).
  children?: ReactNode;
}
export default function ExperienceProductGrid({ data = [], children }: ExperienceProductGridProps) {
  const isMobile = useViewportStore((store) => store.isMobile);
  const count = children != null ? Children.count(children) : data.length;
  const isOneRow = !isMobile ? count <= 3 : false;

  return (
    <GridContainer isOneRow={isOneRow}>
      {children ?? data.map((product) => <ExperienceProductCard key={product.id} {...product} />)}
    </GridContainer>
  );
}

const GridContainer = styled.div<{ isOneRow?: boolean }>`
  display: ${({ isOneRow }) => (isOneRow ? 'flex' : 'grid')};
  gap: 16px;
  width: 100%;
  justify-items: center;

  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); /* 기본 PC 크기 */

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr); /* 태블릿에서는 2개 */
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr); /* 모바일에서도 2개 유지 */
    gap: 10px;
  }

  @media (max-width: 375px) {
    grid-template-columns: repeat(2, minmax(130px, 1fr)); /* 375px 이하에서는 1개 */
  }
`;
